import { useQuery } from '@tanstack/react-query';

import { Payment } from 'src/features/payment/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/billing/payments/:paymentId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    paymentId: string;
}
const queryFn = ({ paymentId, parkingId }: DTO): Promise<Payment> => {
    return axios.get(formatResourcePath(RESOURCE, { paymentId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as PAYMENT_RESOURCE, useQueryHook as useGetPayment };
